module.exports = __webpack_public_path__ + "img/map.90b4a98e.jpg";